import React, { useState } from 'react'
import { connect } from 'react-redux'
import { IFModal, IFText, IFTextArea, IFButton } from 'Components'
import { Colors } from 'Theme'
import { useTranslation } from 'react-i18next'
import Styles from './TerminalModal.module.css'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import { Send } from '@mui/icons-material'
import { SelectPicker } from 'rsuite'
import FormControl from '@mui/material/FormControl'
import styled from 'styled-components'
import JSONPretty from 'react-json-pretty'
import OCPPServices from 'Services/OCPPService'
import { isPropsMatch } from 'Utils/PropsMatch'
import OCPPEnums from 'Enums/OCPPEnums'
import AuthSelectors from 'Stores/Auth/Selectors'
import InfinityEnums from 'Enums/InfinityEnums'

const TerminalContainer = styled.div`
  padding: 0.5rem;
  box-shadow: 0px 0px 4px ${Colors.black};
  border-radius: 5px;
`

const TerminalModal = React.forwardRef(({ chargePoint, operatorUser }, ref) => {
  const { OCPPMessages } = OCPPEnums
  const visibleActions = OCPPMessages.filter((a) => {
    if (a.value === InfinityEnums.OCPPActions.TRIGGER_MESSAGE) {
      return operatorUser.permissions.includes(
        InfinityEnums.OperatorUserPermission.CAN_TRIGGER_MESSAGE,
      )
    }
    return true
  })
  const { t } = useTranslation()
  const [textValue, setTextValue] = useState('')
  const [response, setResponse] = useState()
  const [textError, setTextError] = useState('')
  const [messageType, setMessageType] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const onResponse = (res) => {
    setResponse(res)
    setIsLoading(false)
  }
  const customDialogContentStyle = {
    width: '42rem',
  }

  return (
    <IFModal
      onDismiss={() => {
        setTextValue('')
        setResponse('')
        setTextError('')
        setMessageType('')
        setIsLoading(false)
      }}
      maxWidth={60}
      title={t('TerminalModal.Title')}
      ref={ref}
      dialogContentStyle={customDialogContentStyle}
      style={{ borderRadius: 5 }}
    >
      <div className={Styles.Outer}>
        <div className={Styles.SelectPickerContainer}>
          <IFText className={Styles.Label}>{t('TerminalModal.Type')}</IFText>

          <SelectPicker
            preventOverflow={true}
            menuStyle={{ color: Colors.text, zIndex: 15 }}
            appearance="default"
            searchable={false}
            cleanable={false}
            onSelect={(value) => {
              const i = OCPPMessages.findIndex(
                (message) => message.value === value,
              )
              setResponse('')
              setMessageType(value)
              setTextValue(
                JSON.stringify(OCPPMessages[i]?.description, undefined, 8),
              )
            }}
            onClean={() => {
              setResponse('')
              setMessageType('')
            }}
            data={visibleActions}
            size="md"
          />
        </div>
        <IFText className={Styles.Label}>{t('TerminalModal.Payload')}</IFText>
        <IFTextArea
          value={textValue}
          onChange={(e) => {
            setTextValue(e.target.value)
            if (textError.length > 0) setTextError('')
          }}
          className={Styles.TextArea}
          errorText={textError}
        />
        <div className={response ? Styles.ResponseIn : Styles.ResponseOut}>
          <div className={Styles.ResponseTitle}>
            <IFText className={Styles.Label}>
              {t('TerminalModal.Response')}
            </IFText>
          </div>
          <TerminalContainer>
            <JSONPretty mainStyle="margin:0em" data={response} />
          </TerminalContainer>
        </div>
        <div className={Styles.Container}>
          <IFButton
            text={t('TerminalModal.ButtonText')}
            icon={<Send style={{ fontSize: '18px' }} />}
            color={Colors.primary}
            isFill={true}
            className={Styles.Button}
            isLoading={isLoading}
            size={'sm'}
            isDead={!messageType || textError}
            onClick={() => {
              if (
                textValue.includes('Required') ||
                textValue.includes('Optional')
              ) {
                setTextError(t('TerminalModal.NotAllowed'))
                return
              }
              try {
                JSON.parse(textValue)
              } catch (error) {
                setTextError(t('TerminalModal.InvalidJson'))
                return
              }
              setIsLoading(true)
              OCPPServices.ocppMessage(
                chargePoint._id,
                messageType,
                JSON.parse(textValue),
                onResponse,
              )
            }}
          />
        </div>
      </div>
    </IFModal>
  )
})

const mapStateToProps = (state) => ({
  chargePoint: ChargePointSelectors.getSelectedChargePoint(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
})

function shouldSkipRender(prevProps, nextProps) {
  return isPropsMatch(prevProps, nextProps, ['ocppMesaages', 'chargePoint'])
}

export default React.memo(
  connect(mapStateToProps, null, null, {
    forwardRef: true,
  })(TerminalModal),
  shouldSkipRender,
)
